import React from 'react';
import Page from '../templates/Page';

type QandAProps = {
    question: string,
    answer: string
}

const QandA = ({ question, answer }: QandAProps) => {
    return (
        <div>
            <h3>{question}</h3>
            <p>{answer}</p>
        </div>
    )
}

export default function Support() {
    return (
        <Page>
            <div style={{ color: 'white', padding: 16, width: 800, justifyContent: 'center' }}>
                <div style={{ textAlign: 'center' }}>
                    <h1>Support</h1>
                </div>
                <article style={{ margin: 128 }}>
                    <h2>FAQ</h2>
                    <QandA
                        question="How do I use the app?"
                        answer="To use the app, hit the camera button to open the camera. 
                        On the camera screen adjust the settings for your time-lapse and press the camera button to start capturing photos. 
                        When all of the photos are finished uploading, the app will display a preview of the time-lapse and some controls to make adjustments. 
                        After making adjustments hit the export button to render the images as an mp4 video.
                        Finally you can download the exported video to your phone and share it wherever you like." />
                    <QandA
                        question="What are the settings on the camera screen?"
                        answer="There are settings to control the number of photos to capture, 
                        the fps (frames per second) to capture the photos, the front/back camera, and the aspect ratio of the images." />
                    <QandA
                        question="What are the settings on the preview screen?"
                        answer="There are settings to control the the fps (frames per second) of the playback for the video, 
                        the number of images to blend together, and the number of images to slice together.
                        Blending images together will use the blend mode lighten to combine the brightest parts of multiple images.
                        Slicing images together will crop images into little slices side by side until the frame is filled." />
                </article>
                <article style={{ margin: 128 }}>
                    <h2>Troubleshooting</h2>
                    <QandA
                        question="Why does the app not work without internet?"
                        answer="The app relies on a web based library called remotion to preview and process images into videos.
                        This means photos must be uploaded to be processed on a remote server, rather than locally on your phone." />
                    <QandA
                        question="Where are my downloaded videos?"
                        answer="Videos will be downloaded to your camera roll on iOS or your gallery on Android." />
                    <QandA
                        question="Who can I contact for additional help?"
                        answer="You can email timelapse.editor.app@gmail.com" />
                </article>
            </div>
        </Page>
    )
}